import { ShareButtonsConfig } from "@ui/context/component-config-context";

const shareButtonsConfig: ShareButtonsConfig = {
  buttons: ["facebook", "copy", "rss"],
  popoverButtons: ["facebook", "copy", "rss"],
  giftLinks: {
    subscriberMessaging: (giftCount: number | null) => {
      return <>{giftCount}</>;
    },
    nonSubscriberMessaging: <></>,
    ctaText: "",
    ctaLink: "/subscribe",
    signInText: "",
  },
};

export default shareButtonsConfig;
